import React, { useMemo } from "react";
import Datetime from "react-datetime";
import moment from "moment";
import PropTypes from "prop-types";
import { Container } from "reactstrap";
import styles from "./SyncHeader.module.css";

const SyncHeader = ({ children }) => {
    return (
        <Container fluid>
            <div className={styles.header}>
                {children}
            </div>
        </Container>
    );
};

const Title = ({ children }) => {
    return <h1 className={styles.title}>{children}</h1>;
};

const Subtitle = ({ children }) => {
    return <div className={styles.subtitle}>{children}</div>;
};

const TitleSection = ({ children }) => {
    return <div className={styles.titleSection}>{children}</div>;
};

const Actions = ({ children }) => {
    return <div className={styles.actions}>{children}</div>;
};

const PeriodSelector = ({ value, onPeriodChanged }) => {
    const valueMoment = useMemo(() => moment(value, "YYYY-MM"), [value]);

    return (
        <div style={{ width: "170px" }} className={styles.datePickerWrapper}>
            <Datetime
                dateFormat="YYYY-MM"
                timeFormat={false}
                value={valueMoment}
                onChange={(momentObj) => {
                    if (moment.isMoment(momentObj)) {
                        onPeriodChanged(momentObj.format("YYYY-MM"));
                    }
                }}
                closeOnSelect
                inputProps={{
                    placeholder: "Seleccionar periodo",
                    readOnly: true,
                    className: "form-control"
                }}
            />
        </div>
    );
};

// Compound component pattern
SyncHeader.TitleSection = TitleSection;
SyncHeader.Title = Title;
SyncHeader.Subtitle = Subtitle;
SyncHeader.Actions = Actions;
SyncHeader.PeriodSelector = PeriodSelector;

SyncHeader.propTypes = {
    children: PropTypes.node.isRequired,
};

TitleSection.propTypes = {
    children: PropTypes.node.isRequired,
};

Title.propTypes = {
    children: PropTypes.node.isRequired,
};

Subtitle.propTypes = {
    children: PropTypes.node.isRequired,
};

Actions.propTypes = {
    children: PropTypes.node.isRequired,
};

PeriodSelector.propTypes = {
    value: PropTypes.string.isRequired,
    onPeriodChanged: PropTypes.func.isRequired,
};

export default SyncHeader;
